<template>
	<div class="container-modal form-modal" id="step4">
        <div v-if="$resize && $mq.above(601)" class="content-icon forgot" @mouseover="logoAnim">
			<lottie class="bird-logo active" :options="defaultOptionsLogo" :height="112" :width="112" v-on:animCreated="handleAnimationLogo"/>
        </div>
		<div class="container-holder">
			<div class="info-content">
				<div class="header-modal">
					<div class="title">{{ $t('register.title_step_4') }}</div>
				</div>
				<div class="form-section-register">
					<!-- Date facturare -->

					<div class="input-login-group-tbf w-mob-100 w-tbf-50">
						<div class="personal-choice" v-bind:class="{active: selectedTypePerson == 'company'}" @click="changeTypePerson('company')">
							<div class="type">
								<span class="title">{{ $t('subscription.company_title') }}</span>
								<span>{{ $t('subscription.team') }}</span>
							</div>
							<div class="checkboxes-group">
								<label class="checkbox-tbf">
									<input type="radio" value="company" v-model="selectedTypePerson">
									<span class="checkmark"></span>
								</label>					
							</div>
						</div>
					</div>
					<div class="input-login-group-tbf w-mob-100 w-tbf-50">
						<div class="personal-choice" v-bind:class="{active: selectedTypePerson == 'individual'}" @click="changeTypePerson('individual')">
							<div class="type">
								<span class="title">{{ $t('subscription.individual') }}</span>
								<span>{{ $t('subscription.personal') }}</span>
							</div>
							<div class="checkboxes-group">
								<label class="checkbox-tbf">
									<input type="radio" value="individual" v-model="selectedTypePerson">
									<span class="checkmark"></span>
								</label>					
							</div>
						</div>
					</div>

					<div class="input-login-group-tbf w-mob-100 w-tbf-50" v-bind:class="{has_error: $v.user.complet_name.$error, complete: user.complet_name != '' && !$v.user.complet_name.$error}" v-if="selectedTypePerson == 'individual'">
						<div class="label-input">
							<label>{{ $t('subscription.complet_name') }}</label>
						</div>
						<div class="input-box">
							<div class="icon-left"><icon-people /></div>
							<div class="icon-right" v-if="user.complet_name != ''" @click.stop="user.complet_name = ''"><icon-close /></div>
							<input type="text" :placeholder="$t('subscription.complet_name')" class="input-text" v-model="user.complet_name" ref="first_input">
						</div>
					</div>

					<div class="input-login-group-tbf w-mob-100 w-tbf-50" v-bind:class="{has_error: $v.user.cnp.$error, complete: user.cnp != '' && !$v.user.cnp.$error }" v-if="selectedTypePerson == 'individual'">
						<div class="label-input">
							<label>{{$t('subscription.cnp')}}</label>
						</div>
						<div class="input-box">
							<div class="icon-left"><icon-cnp /></div>
							<div class="icon-right" v-if="user.cnp != ''" @click.stop="user.cnp = ''"><icon-close /></div>
							<input type="text" :placeholder="$t('subscription.cnp')" class="input-text" v-model="user.cnp">
						</div>
					</div>

					<div class="input-login-group-tbf w-mob-100 w-tbf-50" v-bind:class="{has_error: $v.user.company_name.$error, complete: user.company_name != '' && !$v.user.company_name.$error}" v-if="selectedTypePerson == 'company'">
						<div class="label-input">
							<label>{{$t('subscription.company')}}</label>
						</div>
						<div class="input-box">
							<div class="icon-left"><icon-building /></div>
							<div class="icon-right" v-if="user.company_name != ''" @click.stop="user.company_name = ''"><icon-close /></div>
							<input type="text" :placeholder="$t('subscription.company')" class="input-text" v-model="user.company_name">
						</div>
					</div>

					<div class="input-login-group-tbf w-mob-100 w-tbf-50" v-bind:class="{has_error: $v.user.company_cui.$error, complete: user.company_cui != '' && !$v.user.company_cui.$error}" v-if="selectedTypePerson == 'company'">
						<div class="label-input">
							<label>{{ $t('subscription.cui') }}</label>
							<div class="error-msg" v-if="invalidCui">{{ $t('validator.cui_invalid') }}</div>
						</div>
						<div class="input-box">
							<div class="icon-left"><icon-cui /></div>
							<div class="icon-right" v-if="user.company_cui != ''" @click.stop="user.company_cui = ''"><icon-close /></div>
							<input type="text" :placeholder="$t('subscription.cui')" class="input-text" v-model="user.company_cui">
						</div>
					</div>
					<!-- end date facturare -->
					<div class="input-login-group-tbf checkboxes-group">
						<label class="checkbox-tbf no-margin" v-bind:class="{'error-msg': $v.user.terms_and_conditions.$error}">
							<span class="text-checkbox error-msg-terms" href="https://tbf.ro/termeni-si-conditii-tbf-digital/" v-html="$t('subscription.terms', {terms_link: 'https://tbf.ro/termeni-si-conditii-tbf-digital/'})">
							</span>
							<input type="checkbox" value="1" v-model="user.terms_and_conditions">
							<span class="checkmark"></span>
						</label>						
					</div>
				</div>
				<div class="submit-form">
						<button id="buttonNextStep" class="btn-tbf blue center" @click="goNextStep">
							<div class="loader"></div>
							<div class="text">{{$t('register.next_step')}}</div>
						</button>
					</div>
			</div>
		</div>
	</div>
</template>


<script>
	import Lottie from 'vue-lottie';
	import * as animationDataLogo from '../../assets/animations/tbfdigital_logo.json';
	import IconClose from '../Icons/Close'
	import IconPeople from "../Icons/People"
	import IconCnp from '../Icons/Cnp'
	import IconBuilding	from '../Icons/Building'
	import IconCui	from '../Icons/Cui'
	import { required, minLength, requiredIf, sameAs } from 'vuelidate/lib/validators'

	export default {
		data(){
			return {
				defaultOptionsLogo: {
					animationData: animationDataLogo.default,
					autoplay: false,
					loop: false,
				},
				finished: true,
				bird_noti: false,
				optionsCountry: [],
				value_country: '',
				selectedTypePerson: 'company',
				invalidCui: false
			}
		},
		props:{
			user: Object
		},
		components: {
			IconClose,
			IconPeople,
			IconBuilding,
			IconCnp,
			IconCui,
			Lottie
		},
		validations: {
			selectedTypePerson: {required},
			user: {
				terms_and_conditions: { sameAs: val => val === true },
				first_name: {required},
				last_name: {required},
				has_company: '',	
				company_name: {
					required: requiredIf((user) => {
						return user.has_company === 1 || user.has_company === '' 
					})
				},
				company_cui: {
					required: requiredIf((user) => {
						return user.has_company === 1 || user.has_company === '' 
					})
				},
				complet_name: {
					required: requiredIf((user) => {
						return user.has_company === 0
					})
				},
				cnp: {
					required: requiredIf((user) => {
						return user.has_company === 0 
					}), 
					minLength: minLength(13)
				},
			}
		},
		async mounted() {
			this.user.complet_name = this.user.last_name + ' ' + this.user.first_name
			this.logoAnim();
		},
		methods: {
			goNextStep(){
				this.invalidCui = false;

				var buttonName = 'buttonNextStep'
				var btnSubmit = document.getElementById(buttonName);
				var btnSubmitLoader = document.querySelector(`#${buttonName} .loader`)
				var btnSubmitText = document.querySelector(`#${buttonName} .text`)

				btnSubmit.disabled = true
				btnSubmit.classList.add('loading')
				btnSubmitLoader.classList.add('onProgress')
				btnSubmitText.innerHTML = this.$t('btn-submit.loading')

				this.$v.$touch()
				if(this.$v.$invalid){
					btnSubmitLoader.classList.add('finish')
					setTimeout(()=>{
						btnSubmitText.innerHTML = this.$t('btn-submit.error')
						btnSubmit.classList.add('error')
						btnSubmitLoader.classList.remove('onProgress', 'finish')
						btnSubmit.classList.remove('loading')
						setTimeout(()=>{
							btnSubmit.classList.remove('error')
							btnSubmitText.innerHTML = this.$t('register.next_step')
							btnSubmit.disabled = false
						}, 1000)
					}, 300)
				}else{
					if(this.user.has_company){
						this.checkVatNumber()
					}else{
						this.submitRegister()
					}
				}
			},
			handleAnimationLogo(anim){
				this.anim_logo = anim;
				this.anim_logo.setSpeed(1);
			},
			logoAnim(){
				if(this.finished && !this.bird_noti){
					this.finished = false;
					this.anim_logo.play();
					setTimeout(() => {
						this.anim_logo.stop();
						this.finished = true;
					}, 5000);
				}
			},
			submitRegister(){
				var buttonName = 'buttonNextStep'
				var btnSubmit = document.getElementById(buttonName);
				var btnSubmitLoader = document.querySelector(`#${buttonName} .loader`)
				var btnSubmitText = document.querySelector(`#${buttonName} .text`)
                
				var formData = {
					first_name: this.user.first_name,
					last_name: this.user.last_name,
					password: this.user.password,
					email: this.user.email,
					country: this.user.country ? this.user.country.iso : 'RO',
					has_company: this.user.has_company,
					agree_with_terms: this.user.terms_and_conditions,
					package_token: this.user.packageActive.token,
					referral_uuid: this.user.referral_uuid,
					coupon: this.user.coupon
				}
				if(this.user.has_company){
					formData.company_name = this.user.company_name
					formData.cui = `${this.user.country ? this.user.country.iso : 'RO'}${this.user.company_cui}`
				}else{
					formData.name = this.user.complet_name
					formData.cnp = this.user.cnp
				}

				var app = this
				this.$auth.register({
					data: formData,
					redirect: {name: 'payment'},
					staySignedIn: true,
					autoLogin: true,
					fetchUser: true
				})
				.then(() => {
					btnSubmitLoader.classList.add('finish')
					setTimeout(()=>{
						btnSubmitText.innerHTML = this.$t('btn-submit.success')
						btnSubmit.classList.add('completed')
						btnSubmitLoader.classList.remove('onProgress', 'finish')
						btnSubmit.classList.remove('loading')
						setTimeout(()=>{
							btnSubmit.classList.remove('completed')
						}, 1000)
					}, 300)
				}, (res) => {
					let response = res.response.data
					if(response.status == 'error'){
						btnSubmitLoader.classList.add('finish')
						setTimeout(()=>{
							btnSubmitText.innerHTML = this.$t('btn-submit.error')
							btnSubmit.classList.add('error')
							btnSubmitLoader.classList.remove('onProgress', 'finish')
							btnSubmit.classList.remove('loading')
							setTimeout(()=>{
								btnSubmit.classList.remove('error')
								btnSubmitText.innerHTML = this.$t('register.next_step')
							}, 1000)
						}, 300)
					}
				})
				.finally(() => {
					setTimeout(()=>{
						btnSubmit.disabled = false
					}, 1500)
				})
			},
			checkVatNumber(){
				var buttonName = 'buttonNextStep'
				var btnSubmit = document.getElementById(buttonName);
				var btnSubmitLoader = document.querySelector(`#${buttonName} .loader`)
				var btnSubmitText = document.querySelector(`#${buttonName} .text`)
				
				axios.post('/check-vat', {cui: `${this.user.country ? this.user.country.iso : 'RO'}${this.user.company_cui}`})
				.then(({data}) => {
					if(data.is_valid){
						this.submitRegister()
					}else{
						btnSubmitLoader.classList.add('finish')
						setTimeout(()=>{
							btnSubmitText.innerHTML = this.$t('btn-submit.error')
							btnSubmit.classList.add('error')
							btnSubmitLoader.classList.remove('onProgress', 'finish')
							btnSubmit.classList.remove('loading')
							setTimeout(()=>{
								btnSubmit.classList.remove('error')
								btnSubmitText.innerHTML = this.$t('register.next_step')
								btnSubmit.disabled = false

								this.invalidCui = true
							}, 1000)
						}, 300)
					}
				})
			},
			changeTypePerson(type) {
				this.$v.$reset()
				this.selectedTypePerson = type;
				if(this.selectedTypePerson == 'company'){
					this.user.has_company = 1;
				}else{
					this.user.has_company = 0;
				}
			}
		}
	}
</script>